import React from 'react';
import {Filter, ReferenceInput, SelectInput, TextInput, useTranslate} from 'react-admin';

export const LocalisationFilter = (props) => {
    const translate = useTranslate();

    const translateWithCount = (key, count = 1) => {
        const translationKey = `resources.locations.fields.${key}`;
        return count === 1 ? translate(`${translationKey}.one`) : translate(`${translationKey}.other`);
    };

    return (
        <Filter {...props}>
            <ReferenceInput
                label={translateWithCount('type')}
                source="type_id"
                reference="types"
                filter={{"aspect_id": "location"}}
                allowEmpty
            >
                <SelectInput
                    optionText="name"
                    label={translateWithCount('type')}
                    emptyText={translate('resources.locations.selectEmpty.type')}
                />
            </ReferenceInput>
            <ReferenceInput
                label={translateWithCount('scope')}
                source="scope_id"
                reference="scopes"
                filter={{"aspect_id": "location"}}
                allowEmpty
            >
                <SelectInput
                    optionText="name"
                    label={translateWithCount('scope')}
                    emptyText={translate('resources.locations.selectEmpty.scope')}
                />
            </ReferenceInput>
            <TextInput label={translate('resources.locations.fields.fulltext')} source="query"/>
        </Filter>
    );
};
